// ModalViewInvoice.jsx
import React from "react";
import { Modal, Button } from "react-bootstrap";

const ModalViewInvoice = ({ onClose, invoice }) => {
  if (!invoice) return null;

  return (
    <Modal show={true} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Ver factura {invoice.invoice_number}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <strong>Invoice Number:</strong> {invoice.invoice_number}
        </div>
        <div className="mb-3">
          <strong>EntryID:</strong> {invoice.entry_id}
        </div>
        <div className="mb-3">
          <strong>Fecha:</strong>{" "}
          {invoice.date ? new Date(invoice.date).toLocaleString() : "-"}
        </div>
        {invoice.total && (
          <div className="mb-3">
            <strong>Importe total:</strong> {invoice.total} €
          </div>
        )}

        {invoice.pdf_url && (
          <a
            href={invoice.pdf_url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-sm btn-primary"
          >
            Ver PDF
          </a>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalViewInvoice;
